<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Multiselect from "@vueform/multiselect";
import {} from 'devextreme-vue/data-grid';
import Loader from "@/router/views_mobagile/components/loader.vue";
import api from "@/axios";
import Swal from "sweetalert2";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  page: {
    title: "",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Loader, Layout, PageHeader, Multiselect



  },
  data() {

    return {
      title: "Editar Movimento CT-e (Fiscal)",
      items: [
        {
          text: "Movimentos CT-e's (Fiscal)",
          href: "/movctesfiscal/list"
        },
        {
          text: "Editar Movimento CT-e (Fiscal)",
          active: true
        }
      ],
      idData: 0,
      updating: false,
      errosValid: null,
      submitted: false,
      submittedObs: false,
      movCteFiscalData: {},
      movCteFiscalObssData: null,
      movCteFiscalObsData: {},
      movCteFiscalValoresData: null,
      movCteFiscalValorData: {},
      movCteFiscalQtdsData: {},
      movCteFiscalQtdData: {},
      movCteFiscalNotasData: {},
      movCteFiscalNotaData: {},
      movCteFiscalTribsData: {},
      movCteFiscalTribData: {},
      dtListPesqEmit: null,
      dtListPesqRemet: null,
      dtListPesqExped: null,
      dtListPesqReceb: null,
      dtListPesqDest: null,
      showModalObs: false,
      submittedValor: false,
      showModalValor: false,
      submittedQtd: false,
      showModalQtd: false,
      submittedNota: false,
      showModalNota: false,
      showModalTrib: false,
      submittedTrib: false,
      visibleCola1: true,
      paramsEmissorOk: false,
      dtListPesqMov: null,


    };
  },
  created() {

  },

  mounted() {
    console.log('mounted_movcte_fiscal_editar_0')
    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra) {
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)
    this.carregarDados()
  },



  methods: {



    pesqMovChave(evt){
      console.log('pesqMovChave')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/movpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqMov = res.data
        });
      }
    },


    validarCteSefaz(){
      console.log('validarCteSefaz')
      let validImp = false
      if (this.movCteFiscalTribsData) {
        this.movCteFiscalTribsData.forEach((trib) => {
          console.log(trib)
          if (trib.tipo === 'ICMS' && trib.aliquota && trib.valor && trib.vbc){
            validImp = true
          }
        });
      }
      if (validImp === false){
        Swal.fire({
          text: "Favor incluir modalidade, base de cálculo e valor do imposto ICMS e tentar novamente",
          icon: "warning",
          position: "top-end",
          showConfirmButton: false,
          timer: 3500
        })
      } else {
        if (!this.movCteFiscalData.vrec || !this.movCteFiscalData.vtprest || !this.movCteFiscalData.propred || !this.movCteFiscalData.rntrc) {
          Swal.fire({
            text: "Favor preencher os campos Valor a Receber, Valor Total Prestação Serviço, Produto Predominante e RNTRC, e tentar novamente",
            icon: "warning",
            position: "top-end",
            showConfirmButton: false,
            timer: 3500
          })
        } else {
          this.updating = true
          api.get(`${getBaseUrl()}api/movctefisvalcte`, {
            params: { iddata: this.idData }
          }).then((res) => {
            console.log(res.data)
            if (res.data[0] === 'erro') {
              Swal.fire({
                text: res.data[1],
                icon: "warning",
                position: "top-end",
                showConfirmButton: false,
                timer: 3500
              })
            } else {
              console.log('validacao_ok')
              // var blob = new Blob(res.data[1], {type: "text/plain;charset=utf-8"});
              // saveAs.saveAs([res.data[1]], "cte_teste.xml");

              Swal.fire({
                text: res.data[0],
                icon: "success",
                position: "top-end",
                showConfirmButton: false,
                timer: 2500
              })

            }
            this.updating = false
          })
        }
      }
    },


    validarSefazStatus(){
      console.log('validarSefazStatus')
      this.updating = true
      api.get(`${getBaseUrl()}api/movctefisvalsef`, {
        params: { iddata: this.idData }
      }).then((res) => {
        console.log(res.data)
        if (res.data[0] === 'erro') {
          Swal.fire({
            text: res.data[1],
            icon: "warning",
            position: "top-end",
            showConfirmButton: false,
            timer: 2500
          })
        } else {
          console.log('validacao_ok')
          Swal.fire({
            text: res.data[0],
            icon: "success",
            position: "top-end",
            showConfirmButton: false,
            timer: 2500
          })
        }
        this.updating = false
      })
    },



    editarObs(data){
      console.log('editarObs')
      this.movCteFiscalObsData = data
      this.showModalObs = true
    },

    editarValor(data){
      console.log('editarValor')
      this.movCteFiscalValorData = data
      this.showModalValor = true
    },

    editarQtd(data){
      console.log('editarQtd')
      this.movCteFiscalQtdData = data
      this.showModalQtd = true
    },

    editarNota(data){
      console.log('editarNota')
      this.movCteFiscalNotaData = data
      this.showModalNota = true
    },

    editarTrib(data){
      console.log('editarTrib')
      this.movCteFiscalTribData = data
      this.showModalTrib = true
    },

    novaObs(){
      console.log('novaObs')
      this.visibleCola1 = false
      this.movCteFiscalObsData = {}
      this.submittedObs = false
      this.showModalObs = true
    },

    novoValor(){
      console.log('novoValor')
      this.visibleCola1 = false
      this.movCteFiscalValorData = {}
      this.submittedValor = false
      this.showModalValor = true
    },

    novaQtd(){
      console.log('novaQtd')
      this.visibleCola1 = false
      this.movCteFiscalQtdData = {}
      this.submittedQtd = false
      this.showModalQtd = true
    },

    novaNota(){
      console.log('novaNota')
      this.visibleCola1 = false
      this.movCteFiscalNotaData = {}
      this.submittedNota = false
      this.showModalNota = true
    },

    novaTrib(){
      console.log('novaTrib')
      //this.visibleCola1 = false
      this.movCteFiscalTribData = {}
      this.submittedTrib = false
      this.showModalTrib = true
    },

    confObs(){
      console.log('confObs')
      this.submittedObs = true
      if (this.movCteFiscalObsData.xcampo && this.movCteFiscalObsData.xobs) {
        this.showModalObs = false
        this.updating = true
        this.movCteFiscalObsData.movctefis_id = this.idData
        api.post(`${getBaseUrl()}api/movctefisobs`, {
          movCteFiscalObsData: this.movCteFiscalObsData
        }).then((res) => {
          console.log('then axios')
          this.updating = false
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.carregarDados()
        })
      }
    },

    confValor(){
      console.log('confValor')
      this.submittedValor = true
      if (this.movCteFiscalValorData.xnome && this.movCteFiscalValorData.vcomp) {
        this.showModalValor = false
        this.updating = true
        this.movCteFiscalValorData.movctefis_id = this.idData
        api.post(`${getBaseUrl()}api/movctefisval`, {
          movCteFiscalValorData: this.movCteFiscalValorData
        }).then((res) => {
          console.log('then axios')
          this.updating = false
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.carregarDados()
        })
      }
    },

    confQtd(){
      console.log('confQtd')
      this.submittedQtd = true
      if (this.movCteFiscalQtdData.cunid && this.movCteFiscalQtdData.tpmed && this.movCteFiscalQtdData.qcarga) {
        this.showModalQtd = false
        this.updating = true
        this.movCteFiscalQtdData.movctefis_id = this.idData
        api.post(`${getBaseUrl()}api/movctefisqtd`, {
          movCteFiscalQtdData: this.movCteFiscalQtdData
        }).then((res) => {
          console.log('then axios')
          this.updating = false
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.carregarDados()
        })
      }
    },

    confNota(){
      console.log('confNota')
      this.submittedNota = true
      if (this.movCteFiscalNotaData.chave) {
        this.showModalNota = false
        this.updating = true
        this.movCteFiscalNotaData.movctefis_id = this.idData
        api.post(`${getBaseUrl()}api/movctefisnota`, {
          movCteFiscalNotaData: this.movCteFiscalNotaData
        }).then((res) => {
          console.log('then axios')
          this.updating = false
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.carregarDados()
        })
      }
    },

    confTrib(){
      console.log('confTrib')
      this.submittedTrib = true
      if (this.movCteFiscalTribData.tipo) {
        this.showModalTrib = false
        this.updating = true
        this.movCteFiscalTribData.movctefis_id = this.idData
        api.post(`${getBaseUrl()}api/movctefistrib`, {
          movCteFiscalTribData: this.movCteFiscalTribData
        }).then((res) => {
          console.log('then axios')
          this.updating = false
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.carregarDados()
        })
      }
    },


    deletarObs(dataID){
      console.log('deletarObs')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Observação",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/movctefisobs`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
            this.carregarDados()
          })
        }
      })
    },


    deletarValor(dataID){
      console.log('deletarValor')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Valor",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/movctefisval`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
            this.carregarDados()
          })
        }
      })
    },

    deletarQtd(dataID){
      console.log('deletarQtd')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Quantidade",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/movctefisqtd`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
            this.carregarDados()
          })
        }
      })
    },

    deletarNota(dataID){
      console.log('deletarNota')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Nota Fiscal",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/movctefisnota`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
            this.carregarDados()
          })
        }
      })
    },

    deletarTrib(dataID){
      console.log('deletarTrib')
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Tributação",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/movctefistrib`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
            this.carregarDados()
          })
        }
      })
    },

    carregarDados(){
      this.updating = true
      if (this.idData > 0){
        api.get(`${getBaseUrl()}api/movctefis`, {
          params: { iddata: this.idData }
        }).then((res) => {
          console.log(res.data)
          if (res.data.error){
            console.log(res.data.error)
            this.$router.push(`/faltapermissao`);
          }else{
            console.log('then axios')
            console.log(res.data)
            this.movCteFiscalData = res.data[0]
            this.movCteFiscalObssData = res.data[1]
            this.movCteFiscalValoresData = res.data[2]
            this.movCteFiscalQtdsData = res.data[3]
            this.movCteFiscalNotasData = res.data[4]
            this.movCteFiscalTribsData = res.data[5]

            if (this.movCteFiscalData.emit){
              this.dtListPesqEmit = [
                {
                  'codigo': this.movCteFiscalData.emit,
                  'nome': this.movCteFiscalData.emitnome,
                }
              ]
            }
            if (this.movCteFiscalData.remet){
              this.dtListPesqRemet = [
                {
                  'codigo': this.movCteFiscalData.remet,
                  'nome': this.movCteFiscalData.remetnome,
                }
              ]
            }
            if (this.movCteFiscalData.exped){
              this.dtListPesqExped = [
                {
                  'codigo': this.movCteFiscalData.exped,
                  'nome': this.movCteFiscalData.expednome,
                }
              ]
            }
            if (this.movCteFiscalData.receb){
              this.dtListPesqReceb = [
                {
                  'codigo': this.movCteFiscalData.receb,
                  'nome': this.movCteFiscalData.recebnome,
                }
              ]
            }
            if (this.movCteFiscalData.dest){
              this.dtListPesqDest = [
                {
                  'codigo': this.movCteFiscalData.dest,
                  'nome': this.movCteFiscalData.destnome,
                }
              ]
            }

            this.updating = false
            this.paramsEmissorOk = true

          }
        });
      }else{
        this.title = `Criando Novo Movimento CT-e (Fiscal)`
        api.get(`${getBaseUrl()}api/movctefisnv`, {
          params: { iddata: this.idData }
        }).then((res) => {
          console.log('res.data')
          console.log(res.data)

          if (res.data[0] === 'erro') {
            Swal.fire({
              text: res.data[1],
              icon: "warning",
              position: "top-end",
              showConfirmButton: false,
              timer: 2500
            })
            this.paramsEmissorOk = false
          } else {
            this.movCteFiscalData = res.data[0]

            if (this.movCteFiscalData.emit){
              this.dtListPesqEmit = [
                {
                  'codigo': this.movCteFiscalData.emit,
                  'nome': this.movCteFiscalData.emitnome,
                }
              ]
            }



            this.paramsEmissorOk = true
          }
          this.updating = false
        })
      }
    },


    formSubmit(){
      console.log('formSubmit')
      this.submitted = true;
      if (this.movCteFiscalData.dest && this.movCteFiscalData.nct) {
        this.updating = true

        api.post(`${getBaseUrl()}api/movctefis`, {
          movCteFiscalData: this.movCteFiscalData
        }).then((res) => {
          console.log('then axios')
          this.updating = false
          console.log(res)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          if (this.idData === 0){
            this.idData = res.data[0].id
            this.movCteFiscalData = res.data[0]
            this.$router.replace('/movctefiscal/editar/' + this.idData)
          }

        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
        })

      }


    },

    pesqEmitente(evt) {
      console.log('pesqEmitente')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/clipesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqEmit = res.data
        });
      }
    },

    pesqRemetente(evt) {
      console.log('pesqRemetente')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/clipesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqRemet = res.data
        });
      }
    },

    pesqExpedidor(evt) {
      console.log('pesqExpedidor')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/clipesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqExped = res.data
        });
      }
    },

    pesqRecebedor(evt) {
      console.log('pesqRecebedor')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/clipesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqReceb = res.data
        });
      }
    },

    pesqDestinatario(evt) {
      console.log('pesqDestinatario')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/clipesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqDest = res.data
        });
      }
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

  },

};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />




    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">


              <b-button variant="outline-primary" class="mx-2" @click="formSubmit" :disabled="updating || !paramsEmissorOk">
                <i class="bx bx-save font-size-16 align-middle me-2"></i>
                Salvar Alterações
              </b-button>

              <b-button variant="outline-info" class="mx-2" @click="novaObs" :disabled="updating" v-if="movCteFiscalData.id > 0">
                <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                Nova Observação
              </b-button>

              <b-button variant="outline-success" class="mx-2" @click="novoValor" :disabled="updating" v-if="movCteFiscalData.id > 0">
                <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                Novo Valor
              </b-button>

              <b-button variant="outline-warning" class="mx-2" @click="novaQtd" :disabled="updating" v-if="movCteFiscalData.id > 0">
                <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                Nova Quantidade de Carga
              </b-button>

              <b-button variant="outline-danger" class="mx-2" @click="novaNota" :disabled="updating" v-if="movCteFiscalData.id > 0">
                <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                Nova Nota Fiscal
              </b-button>


              <b-button variant="outline-secondary" class="mx-2" @click="novaTrib" :disabled="updating" v-if="movCteFiscalData.id > 0">
                <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                Nova Tributação
              </b-button>

              <b-button variant="outline-warning" class="mx-2" @click="validarSefazStatus" :disabled="updating" v-if="movCteFiscalData.id > 0">
                <i class="bx bx-check-circle font-size-16 align-middle me-2"></i>
                Validar Status Sefaz
              </b-button>

              <b-button variant="outline-secondary" class="mx-2" @click="validarCteSefaz" :disabled="updating" v-if="movCteFiscalData.id > 0">
                <i class="bx bx-send font-size-16 align-middle me-2"></i>
                Enviar CT-e Sefaz
              </b-button>




            </div>
          </div>
        </div>
      </div>
    </div>

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`" show dismissible variant="danger">
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <div class="checkout-tabs" v-if="!updating && paramsEmissorOk">
      <form class="needs-validation" @submit.prevent="formSubmit">


        <div class="card">
          <div class="card-body">

            <b-card-header header-tag="header" role="tab">
              <h6 class="m-0">
                <a v-b-toggle.accordion-1 class="text-dark" href="javascript: void(0);">Informações Principais</a>
              </h6>
            </b-card-header>
            <b-collapse id="accordion-1" v-model="visibleCola1" accordion="my-accordion-1" role="tabpanel">
              <b-card-body>

                <div class="row mb-2">

                  <div class="col-sm-2">
                    <div class="mb-3">
                      <label for="cct">cCT</label>
                      <input id="cct"
                             v-model="movCteFiscalData.cct"
                             type="text"
                             class="form-control"
                             placeholder="Código Numérico que compõe a Chave de Acesso" />
                    </div>
                  </div>

                  <div class="col-sm-2">
                    <div class="mb-3">
                      <label for="nct">Número CT-e</label>
                      <input id="nct"
                             v-model="movCteFiscalData.nct"
                             type="text"
                             class="form-control"
                             :disabled="true"
                             :class="{'is-invalid': submitted && !movCteFiscalData.nct}"
                             placeholder="Número do documento fiscal" />
                      <div v-if="submitted && !movCteFiscalData.nct" class="invalid-feedback">
                        <span>Campo Número do documento obrigatório, favor preencher.</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-2">
                    <div class="mb-3">
                      <label for="serie">Série</label>
                      <input id="serie"
                             v-model="movCteFiscalData.serie"
                             type="text"
                             :disabled="true"
                             class="form-control"
                             placeholder="Série do CT-e" />
                    </div>
                  </div>

                  <div class="col-sm-4">
                    <div class="mb-3">
                      <label for="chave">Chave</label>
                      <input id="chave"
                             v-model="movCteFiscalData.chave"
                             type="text"
                             :disabled="true"
                             class="form-control"
                             placeholder="Chave" />
                    </div>
                  </div>

                  <div class="col-sm-2">
                    <div class="mb-3">
                      <label for="dhemissao">Emissão</label>
                      <input id="dhemissao"
                             v-model="movCteFiscalData.dhemissao"
                             type="datetime-local"
                             class="form-control"
                             :disabled="true"
                             placeholder="Data de Emissão" />
                    </div>
                  </div>




                </div>


                <div class="row mb-2">

                  <div class="col-sm-2">
                    <div class="mb-3">
                      <label for="cfop">CFOP</label>
                      <select id="cfop" v-model="movCteFiscalData.cfop" class="form-control"
                              :disabled="true"
                              :class="{'is-invalid': submitted && !movCteFiscalData.cfop}">
                        <option :value="null" disabled>Descrição da Natureza da Operação do CT-e</option>
                        <option value="6353">Transp a estabelecimento comercial</option>
                      </select>
                      <div v-if="submitted && !movCteFiscalData.cfop" class="invalid-feedback">
                        <span>Campo Natureza de Operação obrigatório, favor preencher.</span>
                      </div>
                    </div>
                  </div>


                  <div class="col-sm-4">
                    <div class="mb-3">
                      <label for="natop">Natureza</label>
                      <input id="natop"
                             v-model="movCteFiscalData.natop"
                             type="text"
                             class="form-control"
                             :disabled="true"
                             placeholder="Código de natureza da circulação dos produtos e da prestação de serviços"/>
                    </div>
                  </div>


                  <div class="col-md-4">
                    <div class="mb-3">
                      <div class="mb-2">
                        <span class="text-black font-18 ">Emitente</span>
                      </div>
                      <multiselect id="inputEmitente"
                                   :disabled="true"
                                   @search-change="pesqEmitente"
                                   v-model="movCteFiscalData.emit"
                                   placeholder="Pesquisar Emitente"
                                   :options="dtListPesqEmit"
                                   :searchable="true"
                                   label="nome"
                                   class="multiselect-size"
                                   track-by="nome"
                                   value-prop="codigo">
                        <template #option="slotProps">
                          <div class="row">
                            <div>
                              <span class="text-info">
                                {{ slotProps.option.codigo }}
                              </span>
                              <span class="mx-4" >
                                {{ slotProps.option.cnpj }}
                              </span>
                            </div>
                            <div class="mt-2 font-size-16">{{ slotProps.option.nome }}</div>
                            <div class="align-items-end text-end align-content-end">{{ slotProps.option.cidade }} - {{ slotProps.option.estado }}</div>
                          </div>
                        </template>
                      </multiselect>
                    </div>
                  </div>



                </div>



                <div class="row mb-2">




                  <div class="col-md-3">
                    <div class="mb-3">
                      <div class="mb-2">
                        <span class="text-black font-18 ">Remetente</span>
                      </div>
                      <multiselect id="inputRemetente"
                                   @search-change="pesqRemetente"
                                   v-model="movCteFiscalData.remet"
                                   placeholder="Pesquisar Remetente"
                                   :options="dtListPesqRemet"
                                   :searchable="true"
                                   label="nome"
                                   class="multiselect-size"
                                   track-by="nome"
                                   value-prop="codigo">
                        <template #option="slotProps">
                          <div class="row">
                            <div>
                              <span class="text-info">
                                {{ slotProps.option.codigo }}
                              </span>
                              <span class="mx-4" >
                                {{ slotProps.option.cnpj }}
                              </span>
                            </div>
                            <div class="mt-2 font-size-16">{{ slotProps.option.nome }}</div>
                            <div class="align-items-end text-end align-content-end">{{ slotProps.option.cidade }} - {{ slotProps.option.estado }}</div>
                          </div>
                        </template>
                      </multiselect>
                    </div>
                  </div>



                  <div class="col-md-3">
                    <div class="mb-3">
                      <div class="mb-2">
                        <span class="text-black font-18 ">Expedidor</span>
                      </div>
                      <multiselect id="inputExpedidor"
                                   @search-change="pesqExpedidor"
                                   v-model="movCteFiscalData.exped"
                                   placeholder="Pesquisar Expedidor"
                                   :options="dtListPesqExped"
                                   :searchable="true"
                                   label="nome"
                                   class="multiselect-size"
                                   track-by="nome"
                                   value-prop="codigo">
                        <template #option="slotProps">
                          <div class="row">
                            <div>
                              <span class="text-info">
                                {{ slotProps.option.codigo }}
                              </span>
                              <span class="mx-4" >
                                {{ slotProps.option.cnpj }}
                              </span>
                            </div>
                            <div class="mt-2 font-size-16">{{ slotProps.option.nome }}</div>
                            <div class="align-items-end text-end align-content-end">{{ slotProps.option.cidade }} - {{ slotProps.option.estado }}</div>
                          </div>
                        </template>
                      </multiselect>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="mb-3">
                      <div class="mb-2">
                        <span class="text-black font-18 ">Recebedor</span>
                      </div>
                      <multiselect id="inputRecebedor"
                                   @search-change="pesqRecebedor"
                                   v-model="movCteFiscalData.receb"
                                   placeholder="Pesquisar Recebedor"
                                   :options="dtListPesqReceb"
                                   :searchable="true"
                                   label="nome"
                                   class="multiselect-size"
                                   track-by="nome"
                                   value-prop="codigo">
                        <template #option="slotProps">
                          <div class="row">
                            <div>
                              <span class="text-info">
                                {{ slotProps.option.codigo }}
                              </span>
                              <span class="mx-4" >
                                {{ slotProps.option.cnpj }}
                              </span>
                            </div>
                            <div class="mt-2 font-size-16">{{ slotProps.option.nome }}</div>
                            <div class="align-items-end text-end align-content-end">{{ slotProps.option.cidade }} - {{ slotProps.option.estado }}</div>
                          </div>
                        </template>
                      </multiselect>
                    </div>
                  </div>


                  <div class="col-md-3">
                    <div class="mb-3">
                      <div class="mb-2">
                        <span class="text-black font-18 ">Destinatário</span>
                      </div>
                      <multiselect id="inputDestinatario"
                                   @search-change="pesqDestinatario"
                                   v-model="movCteFiscalData.dest"
                                   placeholder="Pesquisar Destinatário"
                                   :options="dtListPesqDest"
                                   :searchable="true"
                                   label="nome"
                                   class="multiselect-size"
                                   track-by="nome"
                                   :style="submitted && !movCteFiscalData.dest ? 'border: 1px solid #f86c6b !important;' : ''"
                                   value-prop="codigo">
                        <template #option="slotProps">
                          <div class="row">
                            <div>
                              <span class="text-info">
                                {{ slotProps.option.codigo }}
                              </span>
                              <span class="mx-4" >
                                {{ slotProps.option.cnpj }}
                              </span>
                            </div>
                            <div class="mt-2 font-size-16">{{ slotProps.option.nome }}</div>
                            <div class="align-items-end text-end align-content-end">{{ slotProps.option.cidade }} - {{ slotProps.option.estado }}</div>
                          </div>
                        </template>
                      </multiselect>
                      <div v-if="submitted && !movCteFiscalData.dest">
                        <span class="text-danger font-size-11">Campo Destinatário obrigatório, favor preencher.</span>
                      </div>
                    </div>
                  </div>


                </div>



                <div class="row mb-2">



                  <div class="col-sm-2">
                    <div class="mb-3">
                      <label for="peso">Peso</label>
                      <input id="peso"
                             v-model="movCteFiscalData.peso"
                             type="number"
                             :disabled="true"
                             class="form-control"
                             placeholder="Peso" />
                    </div>
                  </div>


                </div>

                <div class="row mb-2">

                  <div class="col-sm-2">
                    <div class="mb-3">
                      <label for="vcarga">Valor Carga</label>
                      <input id="vcarga"
                             v-model="movCteFiscalData.vcarga"
                             type="number"
                             :disabled="true"
                             class="form-control"
                             placeholder="Valor Carga" />
                    </div>
                  </div>

                  <div class="col-sm-2">
                    <div class="mb-3">
                      <label for="vcargaaverb">Valor Carga Averbado</label>
                      <input id="vcargaaverb"
                             v-model="movCteFiscalData.vcargaaverb"
                             type="number"
                             class="form-control"
                             placeholder="Valor Carga Averbado" />
                    </div>
                  </div>

                  <div class="col-sm-2">
                    <div class="mb-3">
                      <label for="vrec">Valor a Receber</label>
                      <input id="vrec"
                             v-model="movCteFiscalData.vrec"
                             type="number"
                             class="form-control"
                             placeholder="Valor a Receber" />
                    </div>
                  </div>

                  <div class="col-sm-2">
                    <div class="mb-3">
                      <label for="vtottrib">Valor Total Tributado</label>
                      <input id="vtottrib"
                             v-model="movCteFiscalData.vtottrib"
                             type="number"
                             class="form-control"
                             placeholder="Valor Total Tributado" />
                    </div>
                  </div>

                  <div class="col-sm-2">
                    <div class="mb-3">
                      <label for="vtprest">Valor Total Prestação Serviço</label>
                      <input id="vtprest"
                             v-model="movCteFiscalData.vtprest"
                             type="number"
                             class="form-control"
                             placeholder="Valor Total Prestação de Serviço" />
                    </div>
                  </div>

                  <div class="col-sm-2">
                    <div class="mb-3">
                      <label for="valor">Valor</label>
                      <input id="valor"
                             v-model="movCteFiscalData.valor"
                             type="number"
                             class="form-control"
                             placeholder="Valor" />
                    </div>
                  </div>

                </div>


              </b-card-body>

            </b-collapse>
          </div>
        </div>


        <div class="row">
          <div class="card col-md-6">
            <div class="card-body">
              <b-card-header header-tag="header" role="tab">
                <h6 class="m-0">
                  <a v-b-toggle.accordion-3
                     class="text-dark"
                     href="javascript: void(0);">
                    Observações Gerais e do Contribuinte
                  </a>
                </h6>
              </b-card-header>
              <b-collapse id="accordion-3" visible accordion="my-accordion-3" role="tabpanel">
                <b-card-body>
                  <div class="row mb-4">
                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Campo</th>
                          <th scope="col">Observação</th>
                          <th scope="col" class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="data in movCteFiscalObssData" :key="data.id">
                          <td>
                            <h5 class="font-size-14 text-truncate" @click="editarObs(data)">
                              <span class="text-dark">
                                {{ data.id }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.xcampo }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span>
                                {{ data.xobs }}
                              </span>
                            </h5>
                          </td>
                          <td class="text-end">
                            <div class="button-items">
                              <b-button variant="outline-warning" @click="editarObs(data)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="deletarObs(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </div>
          </div>

          <div class="card col-md-6">
            <div class="card-body">
              <b-card-header header-tag="header" role="tab">
                <h6 class="m-0">
                  <a v-b-toggle.accordion-4
                     class="text-dark"
                     href="javascript: void(0);">
                    Valores Componentes
                  </a>
                </h6>
              </b-card-header>
              <b-collapse id="accordion-4" visible accordion="my-accordion-4" role="tabpanel">
                <b-card-body>
                  <div class="row mb-4">
                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Nome</th>
                          <th scope="col" class="text-end">Valor</th>
                          <th scope="col" class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="data in movCteFiscalValoresData" :key="data.id">
                          <td>
                            <h5 class="font-size-14 text-truncate" @click="editarValor(data)">
                              <span class="text-dark">
                                {{ data.id }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.xnome }}
                              </span>
                            </h5>
                          </td>
                          <td class="text-end">
                            <h5 class="font-size-14 text-truncate">
                              <span>
                                {{ formatDecimal(data.vcomp) }}
                              </span>
                            </h5>
                          </td>
                          <td class="text-end">
                            <div class="button-items">
                              <b-button variant="outline-warning" @click="editarValor(data)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="deletarValor(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </div>
          </div>
        </div>



        <div class="row">
          <div class="card col-md-6">
            <div class="card-body">
              <b-card-header header-tag="header" role="tab">
                <h6 class="m-0">
                  <a v-b-toggle.accordion-5
                     class="text-dark"
                     href="javascript: void(0);">
                    Quantidades de Carga
                  </a>
                </h6>
              </b-card-header>
              <b-collapse id="accordion-5" visible accordion="my-accordion-5" role="tabpanel">
                <b-card-body>
                  <div class="row mb-4">
                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Unidade</th>
                          <th scope="col">Medida</th>
                          <th scope="col" class="text-end">Quantidade</th>
                          <th scope="col" class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="data in movCteFiscalQtdsData" :key="data.id">
                          <td>
                            <h5 class="font-size-14 text-truncate" @click="editarQtd(data)">
                              <span class="text-dark">
                                {{ data.id }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.cunid }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span>
                                {{ data.tpmed }}
                              </span>
                            </h5>
                          </td>
                          <td class="text-end">
                            <h5 class="font-size-14 text-truncate">
                              <span>
                                {{ formatDecimal(data.qcarga) }}
                              </span>
                            </h5>
                          </td>
                          <td class="text-end">
                            <div class="button-items">
                              <b-button variant="outline-warning" @click="editarQtd(data)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="deletarQtd(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </div>
          </div>

          <div class="card col-md-6">
            <div class="card-body">
              <b-card-header header-tag="header" role="tab">
                <h6 class="m-0">
                  <a v-b-toggle.accordion-6
                     class="text-dark"
                     href="javascript: void(0);">
                    Notas Fiscais
                  </a>
                </h6>
              </b-card-header>
              <b-collapse id="accordion-6" visible accordion="my-accordion-6" role="tabpanel">
                <b-card-body>
                  <div class="row mb-4">
                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Chave</th>
                          <th scope="col" class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="data in movCteFiscalNotasData" :key="data.id">
                          <td>
                            <h5 class="font-size-14 text-truncate" @click="editarNota(data)">
                              <span class="text-dark">
                                {{ data.id }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.chave }}
                              </span>
                            </h5>
                          </td>
                          <td class="text-end">
                            <div class="button-items">
                              <b-button variant="outline-warning" @click="editarNota(data)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="deletarNota(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </div>
          </div>
        </div>



        <div class="row">


          <div class="card col-md-6">
            <div class="card-body">
              <b-card-header header-tag="header" role="tab">
                <h6 class="m-0">
                  <a v-b-toggle.accordion-7
                     class="text-dark"
                     href="javascript: void(0);">
                    Tributação
                  </a>
                </h6>
              </b-card-header>
              <b-collapse id="accordion-7" visible accordion="my-accordion-7" role="tabpanel">
                <b-card-body>
                  <div class="row mb-4">
                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Tipo</th>
                          <th scope="col">Código</th>
                          <th scope="col">CST</th>
                          <th scope="col">Valor Base Cálculo</th>
                          <th scope="col">Alíquota</th>
                          <th scope="col">Valor</th>
                          <th scope="col" class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="data in movCteFiscalTribsData" :key="data.id">
                          <td>
                            <h5 class="font-size-14 text-truncate" @click="editarTrib(data)">
                              <span class="text-dark">
                                {{ data.id }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.tipo }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.codigo }}
                              </span>
                            </h5>
                          </td>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.cst }}
                              </span>
                            </h5>
                          </td>
                          <td class="text-end">
                            <h5 class="font-size-14 text-truncate">
                              <span>
                                {{ formatDecimal(data.vbc) }}
                              </span>
                            </h5>
                          </td>
                          <td class="text-end">
                            <h5 class="font-size-14 text-truncate">
                              <span>
                                {{ formatDecimal(data.aliquota) }}
                              </span>
                            </h5>
                          </td>
                          <td class="text-end">
                            <h5 class="font-size-14 text-truncate">
                              <span>
                                {{ formatDecimal(data.valor) }}
                              </span>
                            </h5>
                          </td>

                          <td class="text-end">
                            <div class="button-items">
                              <b-button variant="outline-warning" @click="editarTrib(data)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="deletarTrib(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </div>
          </div>
        </div>


        <div class="card">
          <div class="card-body">

            <b-card-header header-tag="header" role="tab">
              <h6 class="m-0">
                <a v-b-toggle.accordion-2 class="text-dark" href="javascript: void(0);">Informações Adicionais</a>
              </h6>
            </b-card-header>
            <b-collapse id="accordion-2" visible accordion="my-accordion-2" role="tabpanel">
              <b-card-body>

                <div class="row mb-2">
                  <div class="col-sm-10">
                    <div class="mb-3">
                      <label for="propred">Produto Predominante</label>
                      <input id="propred"
                             v-model="movCteFiscalData.propred"
                             type="text"
                             class="form-control"
                             placeholder="Produto Predominante"/>
                    </div>
                  </div>

                  <div class="col-sm-2">
                    <div class="mb-3">
                      <label for="rntrc">RNTRC</label>
                      <input id="rntrc"
                             v-model="movCteFiscalData.rntrc"
                             type="text"
                             class="form-control"
                             placeholder="Registro Nacional de Transportadores Rodoviários"/>
                    </div>
                  </div>
                </div>


                <div class="row mb-2">
                  <div class="col-sm-12">
                    <div class="mb-3">
                      <label for="obs">Observações</label>
                      <textarea
                          id="obs"
                          v-model="movCteFiscalData.obs"
                          type="text"
                          rows="3"
                          class="form-control"
                          placeholder="Observações do documento"/>
                    </div>
                  </div>
                </div>

              </b-card-body>

            </b-collapse>
          </div>
        </div>


      </form>
    </div>




    <b-modal size="xl"
             :title="movCteFiscalObsData.id > 0 ? `Editar Observação de CT-e (${ movCteFiscalObsData.id })` : 'Criando nova Observação de CT-e'"
             v-model="showModalObs" centered hide-footer>
      <div class="row">
        <div class="col-sm-12">
          <div class="mb-3">
            <label for="xcampo">Campo</label>
            <input id="xcampo"
                   v-model="movCteFiscalObsData.xcampo"
                   type="text"
                   class="form-control"
                   :class="{'is-invalid': submittedObs && !movCteFiscalObsData.xcampo}"
                   placeholder="Identificação do campo" />
            <div v-if="submittedObs && !movCteFiscalObsData.xcampo" class="invalid-feedback">
              <span>Campo Campo obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="mb-3">
            <label for="xobs">Observação</label>
            <textarea
                id="xobs"
                v-model="movCteFiscalObsData.xobs"
                type="text"
                rows="5"
                class="form-control"
                :class="{'is-invalid': submittedObs && !movCteFiscalObsData.xobs}"
                placeholder="Observação"/>
            <div v-if="submittedObs && !movCteFiscalObsData.xobs" class="invalid-feedback">
              <span>Campo Observação obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>
      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalObs = false">
          <i class="bx bx-sync font-size-16 align-middle me-2"></i>
          Fechar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confObs">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>




    <b-modal size="md"
             :title="movCteFiscalValorData.id > 0 ? `Editar Valor Componente de CT-e (${ movCteFiscalValorData.id })` : 'Criando novo Valor Componente de CT-e'"
             v-model="showModalValor" centered hide-footer>
      <div class="row">
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="xnome">Nome</label>
            <input id="xnome"
                   v-model="movCteFiscalValorData.xnome"
                   type="text"
                   class="form-control"
                   :class="{'is-invalid': submittedValor && !movCteFiscalValorData.xnome}"
                   placeholder="Nome do componente da prestação" />
            <div v-if="submittedValor && !movCteFiscalValorData.xnome" class="invalid-feedback">
              <span>Campo Nome obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="vcomp">Valor</label>
            <input
                id="vcomp"
                v-model="movCteFiscalValorData.vcomp"
                type="number"
                class="form-control"
                :class="{'is-invalid': submittedValor && !movCteFiscalValorData.vcomp}"
                placeholder="Valor componente da prestação"/>
            <div v-if="submittedValor && !movCteFiscalValorData.vcomp" class="invalid-feedback">
              <span>Campo Valor obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>
      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalValor = false">
          <i class="bx bx-sync font-size-16 align-middle me-2"></i>
          Fechar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confValor">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>




    <b-modal size="md"
             :title="movCteFiscalQtdData.id > 0 ? `Editar Quantidade de Carga de CT-e (${ movCteFiscalQtdData.id })` : 'Criando nova Quantidade de Carga de CT-e'"
             v-model="showModalQtd" centered hide-footer>
      <div class="row">
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="cunid">Unidade</label>
            <input id="cunid"
                   v-model="movCteFiscalQtdData.cunid"
                   type="text"
                   class="form-control"
                   :class="{'is-invalid': submittedQtd && !movCteFiscalQtdData.cunid}"
                   placeholder="Unidade da quantidade de carga" />
            <div v-if="submittedQtd && !movCteFiscalQtdData.cunid" class="invalid-feedback">
              <span>Campo Unidade obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="tpmed">Medida</label>
            <input id="tpmed"
                   v-model="movCteFiscalQtdData.tpmed"
                   type="text"
                   class="form-control"
                   :class="{'is-invalid': submittedQtd && !movCteFiscalQtdData.tpmed}"
                   placeholder="Tipo Medida da quantidade de carga"/>
            <div v-if="submittedQtd && !movCteFiscalQtdData.tpmed" class="invalid-feedback">
              <span>Campo Medida obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="qcarga">Quantidade</label>
            <input
                id="qcarga"
                v-model="movCteFiscalQtdData.qcarga"
                type="number"
                class="form-control"
                :class="{'is-invalid': submittedQtd && !movCteFiscalQtdData.qcarga}"
                placeholder="Quantidade de carga"/>
            <div v-if="submittedQtd && !movCteFiscalQtdData.qcarga" class="invalid-feedback">
              <span>Campo Quantidade obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>
      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalQtd = false">
          <i class="bx bx-sync font-size-16 align-middle me-2"></i>
          Fechar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confQtd">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>


    <b-modal size="md"
             :title="movCteFiscalNotaData.id > 0 ? `Editar Nota Fiscal de CT-e (${ movCteFiscalNotaData.id })` : 'Criando nova Nota Fiscal de CT-e'"
             v-model="showModalNota" centered hide-footer>
      <div class="row">

        <div class="col-md-12">

          <div class="mb-3">
            <span>Selecionar Movimento</span>

            <multiselect id="inputMovimento"
                         @search-change="pesqMovChave"
                         v-model="movCteFiscalNotaData.chave"
                         placeholder="Pesquisar movimento"
                         :options="dtListPesqMov"
                         :searchable="true"
                         label="chave"
                         track-by="chave"
                         value-prop="chave">
              <template #option="slotProps">
                <div class="row">
                  <div>
                    <span class="text-info">
                      {{ slotProps.option.id }}
                    </span>
                    <span class="mx-4" >
                      {{ slotProps.option.codigo }}
                    </span>
                  </div>
                  <div class="mt-2 font-size-20">{{ slotProps.option.destnome }}</div>
                  <div class="align-items-end text-end align-content-end">{{ slotProps.option.destcnpj }}</div>
                </div>
              </template>
            </multiselect>

          </div>

        </div>


      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalNota = false">
          <i class="bx bx-sync font-size-16 align-middle me-2"></i>
          Fechar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confNota">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>


    <b-modal size="lg"
             :title="movCteFiscalTribData.id > 0 ? `Editar Tributação de CT-e (${ movCteFiscalTribData.id })` : 'Criando nova Tributação de CT-e'"
             v-model="showModalTrib" centered hide-footer>
      <div class="row">
        <div class="col-sm-4">
          <div class="mb-3">
            <label for="tipo">Tipo</label>
            <select id="tipo" v-model="movCteFiscalTribData.tipo" class="form-control"
                    :class="{'is-invalid': submittedTrib && !movCteFiscalTribData.tipo}">
              <option value="ICMS">ICMS</option>
              <option value="ICMSSUFFIM">ICMS Consumidor Final não contrib. ICMS</option>
            </select>
            <div v-if="submittedTrib && !movCteFiscalTribData.tipo" class="invalid-feedback">
              <span>Campo tipo obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="mb-3">
            <label for="codigo">Código</label>
            <select id="codigo" v-model="movCteFiscalTribData.codigo" class="form-control">
              <option value="00">Tributação Normal ICMS</option>
            </select>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="mb-3">
            <label for="cst">CST</label>
            <select id="cst" v-model="movCteFiscalTribData.cst" class="form-control">
              <option value="00">Tributação Normal ICMS</option>
              <option value="40">ICMS Isenção</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4">
          <div class="mb-3">
            <label for="vbc">Valor Base Cálculo</label>
            <input id="vbc"
                   v-model="movCteFiscalTribData.vbc"
                   type="number"
                   class="form-control"
                   placeholder="Valor Base de Cálculo" />
          </div>
        </div>
        <div class="col-sm-4">
          <div class="mb-3">
            <label for="aliquota">Alíquota</label>
            <input id="aliquota"
                   v-model="movCteFiscalTribData.aliquota"
                   type="number"
                   class="form-control"
                   placeholder="Alíquota" />
          </div>
        </div>
        <div class="col-sm-4">
          <div class="mb-3">
            <label for="valor">Valor</label>
            <input id="valor"
                   v-model="movCteFiscalTribData.valor"
                   type="number"
                   class="form-control"
                   placeholder="Valor" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-3">
          <div class="mb-3">
            <label for="vbcuffim">Base UF Fim</label>
            <input id="vbcuffim"
                   v-model="movCteFiscalTribData.vbcuffim"
                   type="number"
                   class="form-control"
                   placeholder="Base UF Fim" />
          </div>
        </div>
        <div class="col-sm-3">
          <div class="mb-3">
            <label for="pfcpuffim">Perc.Pob.UF Fim</label>
            <input id="pfcpuffim"
                   v-model="movCteFiscalTribData.pfcpuffim"
                   type="number"
                   class="form-control"
                   placeholder="Perc.Pob.UF Fim" />
          </div>
        </div>
        <div class="col-sm-3">
          <div class="mb-3">
            <label for="picmsuffim">Alíquota UF Fim</label>
            <input id="picmsuffim"
                   v-model="movCteFiscalTribData.picmsuffim"
                   type="number"
                   class="form-control"
                   placeholder="Alíquota UF Fim" />
          </div>
        </div>
        <div class="col-sm-3">
          <div class="mb-3">
            <label for="picsminter">Alíquota Interestadual</label>
            <input id="picsminter"
                   v-model="movCteFiscalTribData.picsminter"
                   type="number"
                   class="form-control"
                   placeholder="Alíquota Interestadual" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-3">
          <div class="mb-3">
            <label for="vfcpuffim">Valor Pob. UF Fim</label>
            <input id="vfcpuffim"
                   v-model="movCteFiscalTribData.vfcpuffim"
                   type="number"
                   class="form-control"
                   placeholder="Valor Pob. UF Fim" />
          </div>
        </div>
        <div class="col-sm-3">
          <div class="mb-3">
            <label for="vicmsuffim">Valor Part. UF Fim</label>
            <input id="vicmsuffim"
                   v-model="movCteFiscalTribData.vicmsuffim"
                   type="number"
                   class="form-control"
                   placeholder="Valor Part. UF Fim" />
          </div>
        </div>
        <div class="col-sm-3">
          <div class="mb-3">
            <label for="vicmsufini">Valor Part. UF Ini.</label>
            <input id="vicmsufini"
                   v-model="movCteFiscalTribData.vicmsufini"
                   type="number"
                   class="form-control"
                   placeholder="Valor Part. UF Ini." />
          </div>
        </div>
      </div>

      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalTrib = false">
          <i class="bx bx-sync font-size-16 align-middle me-2"></i>
          Fechar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confTrib">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>



  </Layout>
</template>

